import React from 'react';
import { INLINES } from '@contentful/rich-text-types';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import RichTextContent from 'components/common/contentful/rich_text_content';

const imageStyles = makeStyles((theme) => ({
  retailOption: {
    display: 'block',
    height: '100px',
    background: ({ url }) => `center / contain no-repeat url(${url})`,
    boxShadow: `inset 0 0 0 1px ${theme.color.border}`,
    borderRadius: theme.border.radius.base,
    '&:hover, &:focus': {
      boxShadow: `inset 0 0 0 2px ${theme.color.blue}`,
    },
  },
}));

const RetailOptions = (props) => {
  const { disclaimer, retailOptions } = props;

  const renderNode = {
    // eslint-disable-next-line react/no-unstable-nested-components
    [INLINES.HYPERLINK]: (node, children) => (
      <a href={node.data.uri} target="_blank" rel="noreferrer">
        {children}
      </a>
    ),
  };

  return (
    <>
      {disclaimer && (
        <RichTextContent
          content={disclaimer}
          rendererOptions={{ renderNode }}
          mb={2.5}
        />
      )}

      {retailOptions?.length && (
        <Grid container spacing={1}>
          {retailOptions.map(({ href, image_url }) => {
            const classes = imageStyles({ url: image_url });
            return (
              <Grid item xs={12} md={4} key={href}>
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className={classes.retailOption}
                  aria-label="retailer-link"
                />
              </Grid>
            );
          })}
        </Grid>
      )}
    </>
  );
};

export default RetailOptions;
